<template>
    <v-row>
        <v-dialog v-model="showDialog" persistent max-width="350px">
            <v-form ref="form">
                <v-card>
                    <v-card-text style="padding: 20px;">
                        <v-container>
                            <v-row cols="12" justify="center">
                                <v-icon v-if="type == 'email'" style="font-size: 50px;">mdi-email-newsletter</v-icon>
                                <v-icon v-if="type == 'print'" style="font-size: 50px;">mdi-printer-wireless</v-icon>
                            </v-row>
                            <v-row cols="12" justify="center" style="margin-top: 15px;">
                                <span v-if="type == 'email'" style="font-size: 12px;">{{ $t('wait.preparing-email') }}</span>
                                <span v-if="type == 'print'" style="font-size: 12px;">{{ $t('wait.printing') }}</span>
                            </v-row>
                            <v-row cols="12" justify="center" style="margin-top: 15px;">
                                <v-progress-linear indeterminate striped height="10" color="#C01033"></v-progress-linear>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
    </v-row>
</template>

<script>

export default {
    name: 'WaitDialog',
    data() {
        return {
            showDialog: false,
						type: null,
        }
    },
    methods: {
        open: function(type) {
						this.type = type;
            this.showDialog = true;
        },
        close: function() {
            this.showDialog = false;
        }
    },
  }
</script>